import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FbCoreModule } from '@fleet-beat/core';
import { EditorModule } from '@fleet-beat/editor';
import { AddDocumentDialogContainerComponent } from './components/add-document-dialog-container/add-document-dialog-container.component';

@NgModule({
  declarations: [AddDocumentDialogContainerComponent],
  imports: [CommonModule, MatIconModule, EditorModule, FbCoreModule, MatRippleModule, MatDialogModule],
  entryComponents: [AddDocumentDialogContainerComponent],
})
export class AddDocumentDialogModule {}
